import { useTranslation } from 'react-i18next';
import type { DocumentType } from '~/graphql/graphql';

interface DocumentTypeTagProps {
  type: DocumentType;
}

export function DocumentTypeTag({ type }: Readonly<DocumentTypeTagProps>) {
  const { t } = useTranslation('order');

  return (
    <span className="rounded-full bg-warning-50 px-2.5 py-1 text-xs font-medium text-warning-700">
      {t(`order.documents.types.${type}`)}
    </span>
  );
}
